const actions = {
  // SEND MESSAGE ERROR popups -------------------------------------------
  async errorSendingMessage({dispatch}) {
    dispatch('popups/show/error/sending', 'This message', {root: true})
  },

  // DELETE MESSAGE CONFIRM popups -------------------------------------------
  async confirmDeleteMessage({dispatch},callback) {
    dispatch('popups/show/confirm',{
      message: `Are you sure you want to delete this message?`,
      buttons: [
        {
          name: 'Yes',
          id: 'delete-message',
          colour: 'green',

          function: callback,
        },
        {
          name: 'No',
          id: 'cancel',

          function: close
        }
      ],
    }, {root: true})
  },
  async confirmDeleteAllMessages({dispatch},callback) {
    dispatch('popups/show/confirm',{
      message: `Are you sure you want to delete the entire conversation?`,
      buttons: [
        {
          name: 'Yes',
          id: 'delete-all',
          colour: 'green',

          function: callback,
        },
        {
          name: 'No',
          id: 'cancel',

          function: 'close'
        }
      ],
    }, {root: true})
  },
};

export default {
  namespaced: true,
  actions
};
